/*
 * Author: Dw
 * File Created: Tuesday, 24-07-23 11:39 am
 * Last Modified: Tuesday, 24-12-03 10:06 am, by Roger
 */

// update from https://www.figma.com/design/w89XIcAJwfzL0E1KIJzPkq/DeCard%E8%A7%84%E8%8C%83?node-id=244-1214&node-type=canvas&m=dev
function CheckBoxUnChecked() {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" data-sentry-element="svg" data-sentry-component="CheckBoxUnChecked" data-sentry-source-file="index.tsx">
      <circle cx="12" cy="12" r="9.1" stroke="currentColor" strokeWidth="1.8" data-sentry-element="circle" data-sentry-source-file="index.tsx" />
    </svg>;
}
export default CheckBoxUnChecked;